module.exports = __webpack_public_path__ + "static/img/home_img.2abe7fd4.png";